// This is just an example,
// so you can safely delete all default props below

export default {
    my_account: 'Min konto',
    ticket: 'Billetter',
    signin: 'Logg inn',
    sign_out: 'Logg ut',
    link_terms: 'Billettvilkår',
    link_term_purchase: 'Vilkår - billettkjøp',
    link_term_reservation: 'Vilkår - reservasjon',
    link_term_free_ferry: 'Vilkår - gratis ferje',
    link_term_auto_pass: 'Vilkår - AutoPASS',
    link_term_cancellation: 'Avbestilling av billett',
    link_term_change:'Endring av billett'
}
